<template>
  <t-dropdown ref="habitDropdown">
    <div slot="trigger" slot-scope="{ toggle, blurHandler }">
      <button
        @click="toggle"
        @blur="blurHandler"
        class="flex items-center focus:outline-none"
      >
        {{ selectedHabit.name }}
        <i class="material-icons">arrow_drop_down</i>
      </button>
    </div>
    <div
      v-for="(habit, i) in habits"
      :key="i"
      class="text-black py-2 cursor-pointer hover:bg-gray-200"
      :class="{ 'rounded-t': i === 0, 'rounded-b': i === habits.length - 1 }"
      @click="filterHabits(habit)"
    >
      {{ habit.name }}
    </div>
  </t-dropdown>
</template>

<script>
import habitModule from '@/store/modules/habit.module'
import isEmpty from 'ramda/src/isEmpty'

export default {
  name: 'HabitDropdown',

  props: ['habits'],

  computed: {
    selectedHabit: habitModule.selectedHabit
  },

  methods: {
    filterHabits(habit) {
      this.selectedHabit = habit
      this.$refs.habitDropdown.doHide()
    }
  },

  mounted() {
    if (isEmpty(this.selectedHabit)) {
      this.selectedHabit = this.habits[0]
    }
  }
}
</script>
